import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-testid": "consecutive-hours-block-alert",
  class: "flex flex-col gap-3 rounded-lg p-3 bg-[#fdecec] border border-[#da1e28] text-left"
}
const _hoisted_2 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_3 = { class: "text-sm text-[#16161d] leading-[18px]" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Limite de horas consecutivas:", -1)
const _hoisted_5 = { class: "text-sm text-[#16161d] leading-[18px]" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-[#16161d] leading-[18px]" }, " Plantões que somam na contagem: ", -1)
const _hoisted_7 = { class: "flex flex-col gap-1" }
const _hoisted_8 = {
  key: 1,
  class: "text-sm text-[#16161d] leading-[18px] font-bold"
}

import { computed } from 'vue'
import {
  formatViolationHeadline,
  formatContributingStation,
  formatAvailableAt
} from '@/utils/consecutiveHoursErrors'
import type { ConsecutiveHoursViolation } from '@/Network/Types/Responses/ConsecutiveHoursResponses'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsecutiveHoursBlockAlert',
  props: {
    violations: {},
    bulk: { type: Boolean, default: false },
    showBlockBadge: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;



// Operação em massa é tudo-ou-nada: deixa explícito que nada foi aplicado.
const headerMessage = computed(() =>
  props.bulk || props.violations.length > 1
    ? 'esta operação não pode ser concluída. Nenhum plantão foi alterado.'
    : 'esta alocação não pode ser concluída.'
)

return (_ctx: any,_cache: any) => {
  return (_ctx.violations.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(headerMessage.value), 1)
          ]),
          (_ctx.showBlockBadge)
            ? (_openBlock(), _createBlock(LabelBadge, {
                key: 0,
                label: "IMPEDE",
                color: "red",
                size: "small",
                icon: null
              }))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.violations, (violation, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `${violation.doctorId}-${index}`,
            "data-testid": "consecutive-hours-violation-item",
            class: "flex flex-col gap-1"
          }, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(formatViolationHeadline)(violation)), 1),
            (violation.contributingStations.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_6,
                  _createElementVNode("ul", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(violation.contributingStations, (station, stationIndex) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: stationIndex,
                        class: "text-sm text-[#16161d] leading-[18px]"
                      }, " • " + _toDisplayString(_unref(formatContributingStation)(station)), 1))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_unref(formatAvailableAt)(violation))
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(formatAvailableAt)(violation)), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})